// Stripe.js loaded from a <script> tag (no npm dependency, PLAN.md D3). Minimal typings.
interface StripeElements {
  create(
    type: "payment",
    opts?: Record<string, unknown>,
  ): { mount(el: HTMLElement): void; unmount(): void };
}
export interface StripeJs {
  elements(opts: { clientSecret: string; appearance?: Record<string, unknown> }): StripeElements;
  confirmSetup(opts: {
    elements: StripeElements;
    redirect: "if_required";
    confirmParams?: Record<string, unknown>;
  }): Promise<{
    error?: { message?: string };
    setupIntent?: { id: string; status: string };
  }>;
}
declare global {
  interface Window {
    Stripe?: (key: string) => StripeJs;
  }
}

let loading: Promise<StripeJs> | undefined;

export function stripePublishableKey(): string | undefined {
  const k = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;
  return k ? k : undefined;
}

export function loadStripe(key: string): Promise<StripeJs> {
  loading ??= new Promise((resolve, reject) => {
    if (window.Stripe) return resolve(window.Stripe(key));
    const s = document.createElement("script");
    s.src = "https://js.stripe.com/v3/";
    s.async = true;
    s.onload = () =>
      window.Stripe ? resolve(window.Stripe(key)) : reject(new Error("Stripe.js missing"));
    s.onerror = () => reject(new Error("Stripe.js failed to load"));
    document.head.appendChild(s);
  });
  return loading;
}
